export default function EditIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_16165_6529)">
        <path
          d="M16.5312 9.91211V14.4121C16.5312 16.069 15.1881 17.4121 13.5312 17.4121H4.53125C2.8744 17.4121 1.53125 16.069 1.53125 14.4121V5.41211C1.53125 3.75526 2.8744 2.41211 4.53125 2.41211H9.03125M11.796 3.92917C11.796 3.92917 11.796 5.00189 12.8687 6.07462C13.9415 7.14734 15.0142 7.14734 15.0142 7.14734M6.89725 12.9043L9.14997 12.5825C9.47492 12.536 9.77605 12.3855 10.0082 12.1534L16.0869 6.07461C16.6794 5.48217 16.6794 4.52162 16.0869 3.92917L15.0142 2.85645C14.4217 2.264 13.4612 2.264 12.8687 2.85645L6.78998 8.93521C6.55788 9.16731 6.40731 9.46844 6.36089 9.79339L6.03908 12.0461C5.96756 12.5467 6.39665 12.9758 6.89725 12.9043Z"
          stroke="#3D4A5C"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16165_6529">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.03125 0.912109)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
